module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/main-visual-a6baaf60b99442b5c09927a5d38e9d2c.jpg";